import { batch, useDispatch } from "react-redux";

const openModalAction = () => {
  const resourceName = "error";
  return {
    type: "OPEN_RESOURCE_MODAL",
    payload: { resourceName }
  };
}

const updateErrorsAction = (errors) => {
  return {
    type: "UPDATE_ERRORS",
    payload: { errors }
  };
}

export default () => {
  const dispatch = useDispatch();

  return (url, options) => {
    return $.ajax(url, options).then((data) => {
      if (data) {
        if ("errors" in data) {
          batch(() => {
            dispatch(updateErrorsAction(data.errors));
            dispatch(openModalAction());
          });
        }
      }

      return data;
    }).fail((data) => {
      if (data.responseJSON && "errors" in data.responseJSON) {
        batch(() => {
          dispatch(updateErrorsAction(data.responseJSON.errors));
          dispatch(openModalAction());
        });
      }
    });
  }
}